import { create } from 'zustand';

/**
 * ADR-054 D2: how many uploads are in progress in this tab — transferring,
 * hashing inside the upload, or paused waiting for the network. While any
 * is, useIdleTimer neither warns nor signs the user out: the upload is the
 * activity (the server applies the same rule, within UPLOAD_RESUME_WINDOW).
 */
interface UploadActivityState {
  active: number;
}

const useUploadActivityStore = create<UploadActivityState>(() => ({ active: 0 }));

/** Marks one upload as started; call the returned function (once) when it ends, however it ends. */
export function beginUploadActivity(): () => void {
  useUploadActivityStore.setState((s) => ({ active: s.active + 1 }));
  let ended = false;
  return () => {
    if (ended) return;
    ended = true;
    useUploadActivityStore.setState((s) => ({ active: Math.max(0, s.active - 1) }));
  };
}

/** True while any upload in this tab is in progress (including paused for the network). */
export function isUploadInProgress(): boolean {
  return useUploadActivityStore.getState().active > 0;
}
